import ActiveInvestments from "./ActiveInvestments"

export default ActiveInvestments
